import {
  DOM_ELEMENTS,
  FEEDBACK_MESSAGES,
  FORM_NAMES,
  REGEXS,
  URL_TO_FORM,
  URL_VISITED
} from '../config'
import { addLeadForm } from '../services/addLeadForm'
import { addErrorMsg } from './new-form/addErrorMsg'
import { FORM_TEMPLATE } from './new-form/formTemplate'
import { promoCodeValidation } from './new-form/promoCodeValidation'

/*
999999999
2UU59EE52
2UHEHAU85
EXU2U2E2A
 */

export function addNewForm () {
  if (!URL_TO_FORM.includes(URL_VISITED)) return

  const $advantagesModule = document.getElementById(
    DOM_ELEMENTS.ADVANTAGES_MUDULE_ID
  )

  const newFormWrap = document.createElement('div')
  newFormWrap.innerHTML = FORM_TEMPLATE
  $advantagesModule.parentNode.insertBefore(newFormWrap, $advantagesModule)

  const $form = document.getElementById('wm-form')
  const [$policyCheckbox] = document.getElementsByName(FORM_NAMES.POLICY)

  const $allInputs = $form.querySelectorAll('.wm-form__input')

  $allInputs.forEach((input) => {
    input.addEventListener('input', () => input.nextElementSibling?.remove())
  })

  function handleSubmit (event) {
    event.preventDefault()

    const formData = new FormData(event.target)
    const data = Object.fromEntries(formData)
    const fieldsAndValues = Object.entries(data)

    fieldsAndValues.forEach(([key, value]) => {
      if (key === FORM_NAMES.PHONE && !REGEXS.PORTUGUESE_NUMBER.test(value)) {
        addErrorMsg({
          inputName: key,
          msg: FEEDBACK_MESSAGES.ERROR.PHONE_INVALID
        })
      }

      if (key === FORM_NAMES.PROMO_CODE && value === '') {
        addErrorMsg({
          inputName: key,
          msg: FEEDBACK_MESSAGES.ERROR.PROMO_CODE_REQUIRED
        })
      }

      if (key === FORM_NAMES.PROMO_CODE && value.length !== 9) {
        addErrorMsg({
          inputName: key,
          msg: FEEDBACK_MESSAGES.ERROR.PROMO_CODE_INVALID
        })
      }

      if (key === FORM_NAMES.PROMO_CODE && !promoCodeValidation(value)) {
        addErrorMsg({
          inputName: key,
          msg: FEEDBACK_MESSAGES.ERROR.PROMO_CODE_INVALID
        })
      }
    })

    const thereIsError = $form.querySelectorAll('.wm-form__error')

    if (!$policyCheckbox.checked) return
    if (thereIsError.length > 0) return

    addLeadForm({ data })
  }

  $form.addEventListener('submit', handleSubmit)
}
